import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";

import { useSaveData } from '../../hooks/useSaveData';
import { inspectorApiKeyStore } from '../../api/inspector-api-key-store';
import { CalendarComponent } from '../inspector-calendar/calendar.component';


const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
};

interface BulkSheduleCalendarProps {
  open: boolean;
  inspectorID: any;
  onClosed: () => void;
}

const BulkScheduleCalenderComponent = ({ open, inspectorID, onClosed }: BulkSheduleCalendarProps) => {

  const { isLoading, data, mutateAsync } = useSaveData<any>(inspectorApiKeyStore.inspectionsEvents());

  useEffect(() => {
    if (inspectorID) {
      mutateAsync({ data: { inspectors: [inspectorID] } });
    }
  }, [inspectorID])

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        CALENDAR
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog">
        <CalendarComponent workorderEvent={data?.data?.woEvents} height={645} isLoading={isLoading} />
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="flex-end">
          <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
            Cancel
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default BulkScheduleCalenderComponent;
